/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientRepStatusModel } from '../../models/client-rep-status-model';

export interface GetStatusByRepReport$Plain$Params {

/**
 * year filter
 */
  year: number;

/**
 * month filter 1-12
 */
  month: number;
}

export function getStatusByRepReport$Plain(http: HttpClient, rootUrl: string, params: GetStatusByRepReport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientRepStatusModel>>> {
  const rb = new RequestBuilder(rootUrl, getStatusByRepReport$Plain.PATH, 'get');
  if (params) {
    rb.query('year', params.year, {});
    rb.query('month', params.month, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientRepStatusModel>>;
    })
  );
}

getStatusByRepReport$Plain.PATH = '/api/Report/StatusByRep';
